module.exports = __webpack_public_path__ + "static/media/app_loc.63b0f111.png";